import { render, staticRenderFns } from "./SimpleCreateForm.vue?vue&type=template&id=1b3cdcb2"
import script from "./SimpleCreateForm.vue?vue&type=script&lang=js"
export * from "./SimpleCreateForm.vue?vue&type=script&lang=js"
import style0 from "./SimpleCreateForm.vue?vue&type=style&index=0&id=1b3cdcb2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports